import React from "react";
import "./Why_Contact_Us.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";
import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";

const Why_Contact_Us = () => {
  const highlights = [
    {
      title: "Professional Support",
      description:
        "Get expert assistance and personalized support from our experienced team.",
    },
    {
      title: "Fast Assistance",
      description:
        "Our team is ready to respond to your questions and support your requirements promptly.",
    },
    {
      title: "Easy Communication",
      description:
        "Connect with us through phone, email, or our convenient online contact form.",
    },
  ];

  return (
    <section className="Why_Contact_Us">
      <Container>
        <CommonHeading title="Why Contact Us?" />

        <div className="contact_card_div">
          <Row className="g-4">
            {highlights.map((item, index) => (
              <Col lg={4} md={6} sm={12} key={index}>
                <div className="Contact_Highlights__item">
                  <div className="icon_div">
                    <FontAwesomeIcon icon={faCircleCheck} />
                  </div>

                  <div className="Contact_Highlights__content">
                    <h5>{item.title}</h5>
                    <p>{item.description}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Why_Contact_Us;
